import type { FC } from 'react';
import { useIntl } from 'react-intl';

import ErrorMolecule from 'app/ui/components/molecules/error';

const AccessDenied: FC = () => {
  const intl = useIntl();

  return (
    <ErrorMolecule
      title={intl.formatMessage({ id: 'accessDenied.title', defaultMessage: 'Access Denied' })}
      message={intl.formatMessage({
        id: 'accessDenied.message',
        defaultMessage:
          "You don't have permission to access this page. If you believe this is a mistake, please contact your administrator",
      })}
    />
  );
};

export default AccessDenied;
